import { AxiosRequestConfig } from "axios"
import { HttpClient } from "~/api/HttpClient"
import { AttributesDepartment, AttributesRecruitment, CandidateFormPayload } from "~/types/types"

export const API_PREFIX_PATH = "/api/recruitments"
export const API_PREFIX_DEPARTMENT_PATH = "/api/department-careers-skylinks"
export const API_PREFIX_CANDIDATE_REQUEST_PATH = "/api/candidates"
export const fetchRecruitments = async (searchTerm?: string) => {
  const params: AxiosRequestConfig["params"] = {
    populate: "*",
    sort: "createdAt:desc",
    filters: {
      name: { $containsi: searchTerm },
    },
  }
  return await HttpClient.get(`${API_PREFIX_PATH}`, {
    params,
  })
}

export const fetchRecruitmentId = async (id: number) => {
  const response = await HttpClient.get(`${API_PREFIX_PATH}/${id}?populate=*`)
  return response.data
}

export const updateRecruitment = async (id: string, updatedData: AttributesRecruitment) => {
  return await HttpClient.put(`${API_PREFIX_PATH}/${id}`, { data: updatedData })
}
export const createRecruitment = async (data: AttributesRecruitment) => {
  return await HttpClient.post(`${API_PREFIX_PATH}`, { data })
}

export const deleteRecruitment = async (id: number) => {
  return await HttpClient.delete(`${API_PREFIX_PATH}/${id}`)
}

export const getRecruitmentById = async (id: number) => {
  return await HttpClient.get(`${API_PREFIX_PATH}/${id}`)
}

export const fetchDepartment = async () => {
  return await HttpClient.get(`/api/department-careers-skylinks`)
}

export const createDepartment = async (data: AttributesDepartment) => {
  return await HttpClient.post(`${API_PREFIX_DEPARTMENT_PATH}`, { data })
}

export const checkSlug = async (slug: string) => {
  const params: AxiosRequestConfig["params"] = {
    filters: {
      slug: { $eq: slug },
    },
    publicationState: "preview",
  }
  return await HttpClient.get(`${API_PREFIX_PATH}`, { params })
}

export const createCandidateRequest = async (data: CandidateFormPayload) => {
  return await HttpClient.post(`${API_PREFIX_CANDIDATE_REQUEST_PATH}`, { data })
}
